// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'babel-polyfill'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/iconfont.css'
import Axios from 'axios'
import VueAMap from 'vue-amap'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import Share from 'vue-social-share'
import 'vue-social-share/dist/client.css';
import $ from "jquery"
Vue.use(Share)

import {Mp4} from 'zx-player'
Vue.component('byui-player-Mp4', Mp4)


Vue.use(VueAwesomeSwiper)
Vue.use(ElementUI)
Vue.prototype.$axios = Axios

Vue.prototype.HOST = window.location.origin

Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
key: 'your amap key',
plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
// 默认高德 sdk 版本为 1.4.4
v: '1.4.4'
});
//router.afterEach((to,from,next) => {
//  window.scrollTo(0,0);
//});
// 添加请求拦截器
Axios.interceptors.request.use(function (config) {
  config.headers.common['Access-Control-Allow-Origin'] = "*";
  return config;
}, function (error) {
    return Promise.reject(error);
});
// 添加响应拦截器
Axios.interceptors.response.use(function (response) {
	return response;
}, function (error) {
	return Promise.reject(error);
});
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});
//
//router.afterEach((to,from,next) => {
//window.location.reload();
//});



// WEBPACK FOOTER //
// ./src/main.js